import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M11,11 L9,11 L9,12 L11,12 L11,14 L12,14 L12,12 L14,12 L14,11 L12,11 L12,9 L11,9 L11,11 Z M7.75793083,9 C8.56526147,7.79407079 9.94002198,7 11.5,7 C13.985,7 16,9.015 16,11.5 C16,13.985 13.985,16 11.5,16 C9.54093507,16 7.87397766,14.7476667 7.25612762,13 L6,13 L6,12 L7.02747354,12 C7.00931984,11.8358312 7,11.6690025 7,11.5 C7,10.9740649 7.09025817,10.4691826 7.25612762,10 L6,10 L6,9 L7.75793083,9 Z M2,4 L2,3 L4,3 L4,4 L2,4 Z M6,4 L6,3 L14,3 L14,4 L6,4 Z M6,7 L6,6 L14,6 L14,7 L6,7 Z M2,7 L2,6 L4,6 L4,7 L2,7 Z M2,10 L2,9 L4,9 L4,10 L2,10 Z M2,13 L2,12 L4,12 L4,13 L2,13 Z"/>
  </svg>
);
